import Money from '../src/Money/index.tsx';
export default Money;
